export default __webpack_public_path__ + "static/media/lapto.34b61cd3.png";